import React from 'react'
import Sidebar from '../../Component/Sidebar/Sidebar'
import Header from '../../Component/Header/Header'
import AdminBranchDataContent from '../../Component/AdminBranchDataContent/AdminBranchDataContent'

function AdminBranchData() {
  return (
    <div className="apDiv">
    <Sidebar />
    <div className="body_container" dir="rtl">
      <div className="Header">
        <Header />
      </div>

      <AdminBranchDataContent />
    </div>
  </div>
  )
}

export default AdminBranchData
